import defineComponent from 'flight';
import WithAjax from 'static/script/app/data/with-ajax';
import InitData from 'static/script/app/data/init-data';

function NavigationModal() {

    this._postModal = function (evt, eventData) {
        this.trigger(document, 'data:navigation:before-modal-load', { element: eventData.element });
        this._abortPendingRequests();



        this._request = this._post({
            url: eventData.href,
            data: eventData.data,
            dataType: 'html',
            headers: { 'x-push-state-request': 'true' }
        })
            .done(function () {
                if (eventData.reloadAfterModalClose) {
                    this._reloadAfterModalClose();
                }
            }.bind(this))
            .done(this._showModal.bind(this));
    };

    this._getModal = function (evt, eventData) {
        this.trigger(document, 'data:navigation:before-modal-load');
        this._abortPendingRequests();

        if (eventData.reloadAfterModalClose) {
            this._reloadAfterModalClose();
        }

        this._request = this._get({
            url: eventData.href,
            dataType: 'html',
            headers: { 'x-push-state-request': 'true' }
        }).done(this._showModal.bind(this));
    };

    this._showModal = function (html) {
        this._request = null;
        let initData = InitData.parseHtml(html);
        this.trigger(document, 'ui:modal:open', {
            content: $(html).find('#view'),
            cssClass: 'bidding-modal'
        });
        this.trigger(document, 'data:navigation:after-modal-load', initData);
    };

    this._reloadAfterModalClose = function () {
        this.off(document, 'ui:body-container:on-modal-close', this._reloadPage);
        this.on(document, 'ui:body-container:on-modal-close', this._reloadPage);
    };

    this._reloadPage = function () {
        window.location.href = window.location.href;
    };

    this._abortPendingRequests = function () {
        if (this._request) {
            this._request.reject();
            this._request = null;
        }
    };

    this.after('initialize', function () {
        this.on('data:navigation:post-to-modal', this._postModal);
        this.on('data:navigation:get-to-modal', this._getModal);
        this.on(document, 'ui:body-container:on-modal-close', this._abortPendingRequests);
    });
}

export default defineComponent.component(NavigationModal, WithAjax);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/navigation-modal.js